// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3def361f","453":"47b4a1b9"}[chunkId] + ".chunk.js";
};